import { render, staticRenderFns } from "./diyTable.vue?vue&type=template&id=05e77b03&scoped=true"
import script from "./diyTable.vue?vue&type=script&lang=js"
export * from "./diyTable.vue?vue&type=script&lang=js"
import style0 from "./diyTable.vue?vue&type=style&index=0&id=05e77b03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e77b03",
  null
  
)

export default component.exports